import { ChevronLeft, ChevronRight } from "lucide-react";
import styles from "./Pagination.module.css";

function Pagination({ totalPages, currentPage, setCurrentPage }) {
    return (
        <div className={styles.pagination}>

            <div className={styles.arrows}
                onClick={() => {
                    if (currentPage <= 1) {
                        setCurrentPage(1);
                    } else {
                        setCurrentPage(currentPage - 1);
                    }
                }}
            >
                <ChevronLeft size={16} color="#000"

                />
            </div>
            <div className={styles.page}>
                <p>{currentPage} <span>/ {totalPages}</span></p>
            </div>
            <div className={styles.arrows}>
                <ChevronRight size={16} color="#000"
                    onClick={() => {
                        if (currentPage < totalPages) {
                            setCurrentPage(currentPage + 1);
                        } else if(currentPage >= totalPages) {
                            setCurrentPage(totalPages);
                        }
                    }}
                />
            </div>

        </div>
    )
}

export default Pagination;